import { Alert, AlertIcon, SimpleGrid, useDisclosure, useToast } from "@chakra-ui/react"
import axios from "axios"
import { useFormik } from "formik"
import _, { get } from "lodash"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import * as Yup from "yup"
import { BASE_URL } from "../../../../../consts/app.consts"
import { CUSTOM_REPORT } from "../../../../../consts/methods.consts"
import { REPORT_TAGS } from "../../../../../consts/tags.consts"
import { useGetQuery } from "../../../../../services/api.service"
import { ToastService } from "../../../../../services/toast.service"
import ChakraTable from "../../../../common/chakra-table/ChakraTable"
import InnerLoading from "../../../../common/inner-loading/InnterLoading"
import PageHeader, { PageHeaderActions } from "../../../../common/page-header/PageHeader"
import { useTableDataProvider } from "../../../../hooks"
import { PendingAssessmentColumn, PendingAttendanceColumn, PendingModuleEnrolmentColumn } from "./components/TableColumns"

const StudentEnAndAttendDetailedReport = () => {
    const [length, setLength] = useState(15)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const [searchParams, setSearchParams] = useSearchParams()
    const type: any = searchParams.get('type')

    const filter = {
        page: page,
        length: Number(length),
        from: searchParams.get('from'),
        to: searchParams.get('to'),
        pa_id: searchParams.get('pa_id')
    }


    const { data, isLoading, isFetching } = useGetQuery({
        method: get(reportWiseApi, type),
        body: filter,
        providesTags: [REPORT_TAGS.LIST]
    })

    const { dataList, paginationDetails } = useTableDataProvider(data);

    const onLengthChange = (length: any) => {
        setPage(0)
        setLength(Number(length))
    }

    const onPage = (page: any) => {
        setPage(page)
    }

    if (loading || isLoading) {
        return (
            <>
                <PageHeader enableBackButton isLoading={isFetching || isLoading || loading}
                    subtitle="View and Manage Report" title={get(reportWiseTitle, type, "")} />
                <InnerLoading />
            </>
        )
    }

    return (
        <>
            <div>
                <PageHeader enableBackButton isLoading={isFetching || isLoading || loading}
                    subtitle="View and Manage Report" title={get(reportWiseTitle, type, "")} />

                <ChakraTable onLength={onLengthChange} onPage={onPage} lengthPaginations paginationDetails={paginationDetails} pagination
                    isFetching={isFetching} isLoading={isLoading || loading} size={"sm"}
                    data={dataList || []}
                    title="Report"
                    columns={get(reportWiseTableColumns, type, [])} />

            </div>
        </>
    )
}

export default StudentEnAndAttendDetailedReport

const column = [
    {
        header: "PA Name",
        accessor: "pa",
        width: 400,
    },
    {
        header: "Program Name",
        accessor: "program",
        width: 400,
    },
    {
        header: "Module Name",
        accessor: "module",
        width: 400,
    },
    {
        header: "Start Date",
        accessor: "start_date",
        width: 200,
    },
    {
        header: "End Date",
        accessor: "end_date",
        width: 200,
    }
]

const yesNoOptions = [{
    "label": "Yes",
    "value": "Yes"
}, {
    "label": "No",
    "value": "No"
}]

const reportWiseApi = {
    "module_enrolment": CUSTOM_REPORT.GET_MODULE_ENROLMENT_DETAILED_REPORT,
    "attendance": CUSTOM_REPORT.GET_PENDING_ATTENDANCE_REPORT,
    "assessment": CUSTOM_REPORT.GET_PENDING_ASSESSMENT_REPORT
}

const reportWiseTitle = {
    "module_enrolment": "Pending Module Enrolment Report",
    "attendance": "Pending Session Attendance Report",
    "assessment": "Pending Assessment Report"
}

const reportWiseTableColumns = {
    "module_enrolment": PendingModuleEnrolmentColumn,
    "attendance": PendingAttendanceColumn,
    "assessment": PendingAssessmentColumn
}
